import { useCallback, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { PERMISSIONS, PERMISSIONS_LIST } from '../../../../const/permissions.const';
import useCheckPermissions from '../../../../hooks/useCheckPermissions';
import { IReduxAppState } from '../../../../reducers';

export interface Permission {
    id: string;
    permission_set: string;
    value: boolean;
  }
  
const usePermissionChecklist = (watch: any, setValue: any) => {

  const [permissions, setPermissions] = useState<any>([]);
  const formPermissions = watch!('permissions');
  const isSelf = watch!('isSelf');
  const isSuperuser = watch!('isSuperuser');
  const merchant = useSelector((state: IReduxAppState) => state.merchant);
  const merchantPermissions = useSelector((state: IReduxAppState) => state.permissions);
  const { hasPermission: hasAdminPermission} = useCheckPermissions(PERMISSIONS.ADMIN);

  const setMultiplePermissions = useCallback((value: boolean, exclusionList?: string[]) => {
      permissions.forEach((permission: Permission, idx: number) => {
          if(!exclusionList?.includes(permission.permission_set) && merchantPermissions[permission.permission_set] && !(isSuperuser && PERMISSIONS_LIST[permission.permission_set as PERMISSIONS].requiredForSuperuser)){
              setValue!(`permissions[${idx}].value`, value);
          }
      });
      // eslint-disable-next-line
  }, [ permissions, setValue,merchantPermissions ])

  const onSelectAll = () => {
    setMultiplePermissions(true, !hasAdminPermission ? ['admin']:[])
  };
  const onSelectNone = () => {
    setMultiplePermissions(false, !hasAdminPermission ? ['admin']:[])
  };

  const isSelectAllDisabled = permissions.every((permission: Permission) => permission.value);
  const isSelectNoneDisabled = permissions.every((permission: Permission) => !permission.value);

  const onPermissionChange = useCallback((e: any, keyName: string) => {
    e.persist();
    const name = `${e?.target?.name}`;
    const value = e?.target?.checked ?? false;

    const adminIdx = permissions.findIndex((permission: Permission) => permission.permission_set === 'admin');
    const adminPermission = permissions[adminIdx];

    if (keyName === 'admin' && !adminPermission.value)  {
      setMultiplePermissions(true);
    }

    if (keyName !== 'admin' && !value)  {
      adminPermission.value = false;
    }

    setValue!(name, value);
  }, [ permissions, setValue, setMultiplePermissions ]);

    useEffect(() => {
      formPermissions.sort((a:Permission, b:Permission) => a?.permission_set.localeCompare(b?.permission_set))
      setPermissions(formPermissions);
    }, [formPermissions]);

    return {
        permissions,
        isSelectAllDisabled,
        isSelectNoneDisabled,
        onSelectAll,
        onSelectNone,
        onPermissionChange,
        isSelf,
        isSuperuser,
        merchant
    }
}

export default usePermissionChecklist;